module.exports = __webpack_public_path__ + "static/img_9810-ae84d811d416141b28b1bb918b0bc812.webp";